import { Mail, MessageCircle } from 'lucide-react';

export default function ChannelCards() {
  const { t } = useTranslation();
  const channels = [
    { icon: <Mail size={24} />, title: t('support.channel2_title'), info: t('support.channel2_addr'), sub: t('support.channel2_time'), color: 'bg-emerald-50 text-emerald-600' },
    { icon: <MessageCircle size={24} />, title: t('support.channel3_title'), info: t('support.channel3_btn'), sub: t('support.channel3_status'), color: 'bg-amber-50 text-amber-600', isChat: true },
  ];
  return (
    <section className="py-16 px-4">
      <div className="max-w-2xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {channels.map((c, i) => (
          <div key={i} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm hover:shadow-md transition-shadow text-center">
            <div className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl ${c.color} mb-4`}>{c.icon}</div>
            <h3 className="font-display font-bold text-slate-900 mb-2">{c.title}</h3>
            {c.isChat ? (
              <button className="text-primary-600 font-semibold text-sm hover:underline">{c.info}</button>
            ) : (
              <p className="text-primary-600 font-semibold text-sm">{c.info}</p>
            )}
            <p className="text-slate-400 text-xs mt-1">{c.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
